/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeraetDto } from '../../models/geraet-dto';

export interface GetAllGeraete$Json$Params {
}

export function getAllGeraete$Json(http: HttpClient, rootUrl: string, params?: GetAllGeraete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeraetDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllGeraete$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeraetDto>>;
    })
  );
}

getAllGeraete$Json.PATH = '/v1/geraete/all';
